import useQuery from './use-query';

export { useQuery };

export default useQuery;
